import { render, staticRenderFns } from "./SvehicleinvoiceUpdate.vue?vue&type=template&id=48aec971&scoped=true"
import script from "./SvehicleinvoiceUpdate.vue?vue&type=script&lang=js"
export * from "./SvehicleinvoiceUpdate.vue?vue&type=script&lang=js"
import style0 from "./SvehicleinvoiceUpdate.vue?vue&type=style&index=0&id=48aec971&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48aec971",
  null
  
)

export default component.exports